import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const TOKEN_KEY = "brep_token";
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!token) { setUser(null); setReady(true); return; }
    api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(null); setUser(null); })
      .finally(() => setReady(true));
  }, [token]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
  };
  const signup = async (email, password, first_name) => {
    const r = await api.post("/auth/signup", { email, password, first_name });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null); setUser(null);
  };
  // Replace the active JWT (e.g. after change-password returns a fresh one).
  const applyToken = (newToken) => {
    if (!newToken) return;
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  };

  return (
    <AuthCtx.Provider value={{ token, user, ready, login, signup, logout, setToken: applyToken }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

// axios helper with token
export const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});
